import React from "react";
import { Link, useLocation } from "react-router-dom";

// =============================================================================
// 1. ASSET IMPORTS
// =============================================================================
import logoImg from "../assets/logo.png";

import iconUser from "../assets/user.png";         
import iconInitiate from "../assets/initiate.png"; 
import iconCreate from "../assets/create.png";     
import iconDash from "../assets/dash.png";         
import iconUserDash from "../assets/userdash.png"; 
import iconAudit from "../assets/auditdash.png";   
import iconOverview from "../assets/overview.png"; 
import iconVoucher from "../assets/voucher.png";   
import iconUpload from "../assets/upload.png";     
import iconApprove from "../assets/approve.png";   

// =============================================================================
// 2. CONFIGURATION
// =============================================================================

const navIcons = {
  "new-coordinator": iconUser,
  "user-registration": iconUser,     // Register Coordinator / User Registration
  "initiate-project": iconInitiate,
  "create-project": iconCreate,
  "dashboard": iconDash,
  "user-dashboard": iconUserDash,
  "audit-dashboard": iconAudit,
  "overview": iconOverview,
  "create-voucher": iconVoucher,
  "vendor-dashboard": iconDash,
  "beneficiary-list": iconUpload, 
  "upload-beneficiary-list": iconUpload,
  "approve-beneficiary-list": iconApprove
};

const navItems = {
  "dashboard": "Dashboard",
  "user-registration": "User Registration",  // ✅ Matches Screenshot
  "create-project": "Create Project",        // ✅ Matches Screenshot (was Define Project)
  "create-voucher": "Create Voucher",
  "initiate-project": "Initiate Project",
  "beneficiary-list": "Beneficiary List", 
  "upload-beneficiary-list": "Upload List",
  "approve-beneficiary-list": "Approve List", 
  "new-coordinator": "Register Coordinator",
  "user-dashboard": "User Dashboard",
  "overview": "Overview",
  "vendor-dashboard": "Vendor Dashboard",
  "audit-dashboard": "Audit Dashboard"
};

// =============================================================================
// 3. COMPONENT
// =============================================================================

const Header = ({ currentUser, sidebarOpen, setSidebarOpen }) => {
  const location = useLocation();

  const getActiveClass = (routeKey) => {
    const path = "/" + routeKey;
    return location.pathname === path ? "menu-item active" : "menu-item";
  };

  return (
    <nav className={`sidebar ${sidebarOpen ? "" : "closed"}`} id="sidebar">
      
      {/* Toggle Button */}
      <button 
        className="toggle-btn" 
        onClick={() => setSidebarOpen(!sidebarOpen)}
        title={sidebarOpen ? "Collapse Sidebar" : "Expand Sidebar"}
      >
        <i className={`fa-solid ${sidebarOpen ? 'fa-chevron-left' : 'fa-chevron-right'}`}></i>
      </button>

      {/* Sidebar Header */}
      <div className="sidebar-header">
        <img src={logoImg} alt="VRES Logo" className="logo-img" />
        <span className="logo-text-short">VRES</span>
      </div>

      {/* Navigation Links */}
      <div className="nav-links">
        {currentUser && currentUser.nav && currentUser.nav.map((routeKey) => (
          <Link
            key={routeKey}
            to={`/${routeKey}`}
            className={getActiveClass(routeKey)}
            title={!sidebarOpen ? navItems[routeKey] : ""}
          >
            <span className="menu-icon">
              <img 
                src={navIcons[routeKey] || iconOverview} 
                alt={routeKey} 
              />
            </span>
            <span className="menu-text">
              {navItems[routeKey] || routeKey}
            </span>
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default Header;